module.exports = __webpack_public_path__ + "static/media/spinner.d7ef3aa2.gif";